import * as React from "react"
import PropTypes from "prop-types"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from 'styled-components';
import Social from './social';

const StyledAuthorBio = styled.div` 
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 20px;
    align-items: center;
    margin: 22px 0;
    padding: 20px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    
    img{
        border-radius: 50%;
    }
    
    @media (max-width: 850px){
    	grid-template-columns: 1fr;
    	justify-items: center;
    	text-align: center;
	}
    
`;

const StyledAuthorInfo = styled.div`
    span {
        display: inline-block;
        margin-bottom: 14px;
        font-size: 14px;
        margin-top: 7px;
    }

    h5 {
        font-size: 20px;
        line-height: 24px;
        font-weight: 700;
        margin: 0 0 10px 0;
        padding-top: 0;
    }

    p {
        margin-bottom: 10px;
    }

    @media (max-width: 850px){  
        ul{
            justify-content: center;
        }   
    }
`;
const Bio = ({author}) => {
  
  const image = getImage(author.avatar)

  return (
    <StyledAuthorBio>
      <GatsbyImage image={image} alt={author.bio} /> 

      <StyledAuthorInfo>
		<span className="post-by">Written by</span>
		<h5>{author.name}</h5>
		<p>{author.bio || null}</p>
        <Social className="social" social={author.social}/>
      </StyledAuthorInfo>
    </StyledAuthorBio>
  )
}



Bio.propTypes = {
  author: PropTypes.object.isRequired,
};

export default Bio

